export default "__VITE_ASSET__wOF4dPH8__"